import React from "react";
import { BulletPoints } from "./BulletPoints";
import { Invest } from "./Invest";

export const InvestCard1 = ({ plan, img }) => {
  return (
    <div className="text-black rounded-lg overflow-hidden font-body shadow">
      <img className="" src={img} />
      <div className="p-2">
        <h2 className="text-lg">{plan.planName}</h2>
        <p className="text-sm text-gray-500 mt-2">
          <span className="text-primary">{plan.profitProduction}%</span> return
          in {plan.duration} day
        </p>
        <div className="grid grid-cols-2 mt-2">
          <div>
            <h4>${plan.minAmount} </h4>
            <p className="text-xs text-gray-500">min</p>
          </div>
          <div>
            <h4>${plan.maxAmount} </h4>
            <p className="text-xs text-gray-500">max</p>
          </div>
        </div>

        <Invest fromWallet={false} />
      </div>
    </div>
  );
};
